import { render, staticRenderFns } from "./Marzipano.vue?vue&type=template&id=8471d4fe&scoped=true&"
import script from "./Marzipano.vue?vue&type=script&lang=js&"
export * from "./Marzipano.vue?vue&type=script&lang=js&"
import style0 from "./Marzipano.vue?vue&type=style&index=0&id=8471d4fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8471d4fe",
  null
  
)

export default component.exports